<template>
  <div class="rename-wrapper container-inner pt-30 pb-50">
    <h5 class="c-text_title">マイページ</h5>
    <div class="tile is-ancestor">
      <div class="tile is-3 is-sidebar is-vertical is-parent">
        <div class="tile is-child"><SidebarMyPage /></div>
      </div>
      <div class="tile is-parent">
        <div class="tile is-child content-padding">
          <h4 class="mypage-block-title mb-30">ニックネームの変更</h4>
          <message-area></message-area>
          <div class="columns">
            <div class="column is-half-desktop is-three-fifths-mobile" style="padding-right: 0px">
              <b-field
                :message="$v.newName.$error ? $t('EF2210_Content') : ''"
                :type="$v.newName.$error ? 'is-danger' : ''"
              >
                <b-input
                  v-model="newName"
                  :placeholder="$t('C010_27')"
                  maxlength="30"
                  expanded
                  @blur="$v.newName.$touch"
                />
              </b-field>
            </div>
            <div class="column">
              <a class="button is-primary" @click="changeName">変更</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" /></div
></template>
<style lang="scss" src="./rename.scss" scoped>
</style>

<script>
import SidebarMyPage from '@/components/sidebar/sidebar-mypage/sidebar-mypage';
import { updateUsername } from '../../../../services/profile.service';
import { validationMixin } from 'vuelidate';
import MessageArea from '@/components/common/message-area/message-area.vue';
import messageUtils from '@/utils/mixins/messageUtils';
import maxLength from 'vuelidate/src/validators/maxLength';
import required from 'vuelidate/src/validators/required';
import { getCurrentUser, getUserSession, logout } from '../../../../services/user.service';

export default {
  name: 'Rename',
  components: {
    SidebarMyPage,
    'message-area': MessageArea
  },
  mixins: [messageUtils, validationMixin],
  data() {
    return {
      newName: ''
    };
  },
  validations: {
    newName: {
      required,
      maxLength: maxLength(30)
    }
  },
  async created() {
    if (!getUserSession()) {
      await logout();
      this.$router.push({
        name: 'login',
        params: {
          page_expectations: this.$route.path
        }
      });
    }
  },
  async mounted() {
    this.loading++;
    const user = await getCurrentUser();
    if (user) {
      this.newName = user.displayName;
    }
    this.loading--;
  },
  methods: {
    async changeName() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.clearMessage();
      this.loading++;
      const res = await updateUsername(null, this.newName);
      this.loading--;
      if (res.status) {
        this.setSuccessMessage(res.result);
        this.$store.commit('cusRegister/updateUserName', this.newName);
      } else {
        this.setErrorMessage(res.result);
      }
    }
  }
};
</script>
